export default {
    "processing": "В обработке",
    "complete": "Оплачен",
    "canceled": "Отменен",
    "error": "Ошибка",
}